import { ApplicationRef, ChangeDetectorRef, Component, ElementRef, EventEmitter, HostListener, OnInit, Output, ViewChild, ViewContainerRef } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { CabinetService } from 'src/app/services/office/cabinet.service';
import { ReferentielService } from 'src/app/services/referentiel/referentiel.service';
import { LoginService } from 'src/app/services/login/login.service';
import { Paginated } from 'src/app/utils/interfaces/new/paginated.interface';
import { Liste } from 'src/app/utils/interfaces/new/Liste';
import { Choix } from 'src/app/utils/interfaces/new/Choix';
import { CritereAttache } from 'src/app/utils/interfaces/new/CritereAttache';
import { ListeChoixService } from 'src/app/services/liste-choix/liste-choix.service';
import { FlatTreeControl, NestedTreeControl } from '@angular/cdk/tree';
import { MatTreeFlatDataSource, MatTreeFlattener, MatTreeNestedDataSource } from '@angular/material/tree';
import { SelectionModel } from '@angular/cdk/collections';
import { MatTree } from '@angular/material/tree';
import { environment } from 'src/environments/environment';

export class AideSaisie {
  name: string;
  children: AideSaisie[] = [];

  constructor(name: string) {
    this.name = name;
  }

  public clone(): AideSaisie {
    const clone = new AideSaisie(this.name);
    for (let child of this.children) {
      clone.children.push(child.clone());
    }
    return clone;
  }
}

/** Flat node with expandable and level information */
interface FlatTreeNode {
  expandable: boolean;
  name: string;
  node: AideSaisie;
  level: number;
  id: string;
}

@Component({
  selector: 'app-aide-saisie',
  templateUrl: './aide-saisie.fragment.html',
  styleUrls: [
    './aide-saisie.fragment.scss',
    '../modal.fragment.scss'
  ]
})
export class AideSaisieFragment implements OnInit {
  private _transformer = (node: AideSaisie, level: number) => {
    return {
      expandable: !!node.children && node.children.length > 0,
      name: node.name,
      node: node,
      level: level
    };
  }

  treeControl = new FlatTreeControl<FlatTreeNode>(node => node.level, node => node.expandable);
  treeFlattener = new MatTreeFlattener(this._transformer, node => node.level, node => node.expandable, node => node.children);
  dataSource = new MatTreeFlatDataSource(this.treeControl, this.treeFlattener);

  @ViewChild('treeSelector') tree: MatTree<AideSaisie>;
  @ViewChild('modalBody') public modalBody: ElementRef;
  @ViewChild('outsideModal') public outsideModal: ElementRef;

  public modalTitle: string;
  public formGroup: FormGroup;
  public listeGroup: FormGroup;
  public choixGroup: FormGroup;
  public isError = false;
  public errorMessage = '';
  public attacheToEdit: CritereAttache
  editingListe: Liste;
  aideSaisieBlob: AideSaisie[];
  linkedIds: string[] = [];

  @Output() public closeEmitter = new EventEmitter();

  @HostListener('document:mousedown', ['$event'])
  onGlobalClick(event): void {
    if (!environment.closeModalOnClickOutside) {
      return;
    }

    if (!this.modalBody.nativeElement.contains(event.target) && this.outsideModal.nativeElement.contains(event.target)) {
      this.closeAddEditModal();
    }
  }

  listesBodyTable: Paginated<Liste>;
  listesColumnTable = [
    { title: 'Nom de la liste', data: 'nom' },
    { title: 'Modifier choix', data: null }
  ];
  choixBodyTable: Paginated<Choix>;
  choixColumnTable = [
    { title: 'Nom du choix', data: 'nom' },
    { title: 'Supprimer', data: null }
  ];

  constructor(
    private _formBuilder: FormBuilder,
    private _cabinet: CabinetService,
    private _ref: ReferentielService,
    private _login: LoginService,
    private _listeChoix: ListeChoixService,
    private changeDetectorRefs: ChangeDetectorRef,
    private applicationRef: ApplicationRef,
    private _view: ViewContainerRef
  ) { }

  hasChild = (_: number, node: FlatTreeNode) => node.expandable;

  async ngOnInit(): Promise<void> {
    if (this.attacheToEdit && this.attacheToEdit.critereList) {
      this.aideSaisieBlob = JSON.parse(this.attacheToEdit.critereList);
      this.dataSource.data = this.aideSaisieBlob;
      if (this.dataSource.data && this.dataSource.data.length > 0) {
        for (let node of this.treeControl.dataNodes) {
          setTimeout(() => {
            node.id = node.name + Date.now().toString();
            this.linkedIds.push("treeNode_" + node.id);
          }, 5);
        }
      } else {
        this.linkedIds.push("treeDrop");
      }
    } else {
      this.linkedIds.push("treeDrop");
    }

    this.listesBodyTable = await this._listeChoix.findListes();

    this.formGroup = this._formBuilder.group({
      defaultValue: [this.attacheToEdit.defaultValue]
    });
    this.listeGroup = this._formBuilder.group({
      listeName: ['']
    });
    this.choixGroup = this._formBuilder.group({
      choixName: ['']
    });
  }

  async editListe(event: any) {
    this.editingListe = event;
    this.choixBodyTable = await this._listeChoix.findByListeId(this.editingListe.id);
  }

  async onSubmitListe() {
    this.listeGroup.markAllAsTouched();
    if (this.listeGroup.valid && this.listeGroup.controls['listeName'].value && this.listeGroup.controls['listeName'].value !== '') {
      const newListe: Liste = {
        nom: this.listeGroup.controls['listeName'].value,
        author: this._login.getCurrentProfil().id
      }
      await this._listeChoix.createListe(newListe);
      this.listeGroup.controls['listeName'].setValue('');
      this.listesBodyTable = await this._listeChoix.findListes();
    }
  }

  async onSubmitChoix() {
    this.choixGroup.markAllAsTouched();
    if (this.choixGroup.valid && this.choixGroup.controls['choixName'].value && this.choixGroup.controls['choixName'].value !== '') {
      const newChoix: Choix = {
        nom: this.choixGroup.controls['choixName'].value,
        idListe: this.editingListe.id
      }
      await this._listeChoix.createChoix(newChoix);
      this.choixGroup.controls['choixName'].setValue('');
      this.choixBodyTable = await this._listeChoix.findByListeId(this.editingListe.id);
    }
  }

  async deleteChoix(event: any) {
    await this._listeChoix.deleteChoix(event.id);
    this.choixBodyTable = await this._listeChoix.findByListeId(this.editingListe.id);
  }

  public closeAddEditModal(object?: any): void {
    if (object) {
      this.closeEmitter.emit(object);
    } else {
      this.closeEmitter.emit(null);
    }
  }

  public stopPropagation(event): void {
    event.stopPropagation();
  }

  public async onSubmit(event: any): Promise<void> {
    // on vérifie si on a bien cliqué sur le bouton de soumission
    // pour eviter le "enter" qui soumet le formulaire
    if (event.composedPath() && event.composedPath().length >= 2 && event.composedPath()[1].id === "subButton") {
      this.formGroup.markAllAsTouched();
      if (this.formGroup.valid) {
        this.attacheToEdit.defaultValue = this.formGroup.controls['defaultValue'].value ? this.formGroup.controls['defaultValue'].value : '';
        this.attacheToEdit.critereList = JSON.stringify(this.dataSource.data);
        this.closeAddEditModal(this.attacheToEdit);
      } else {
        // this.isError = true;
        // this.errorMessage = 'Impossible d\'ajouter l\'aide à la saisie';
        // setTimeout(() => {
        //   this.isError = false;
        // }, 5000);
        console.debug('Form validated without button click -- do nothing');
      }
    }
  }

  refreshDataSource(newAideSaisie: AideSaisie[]) {
    this.dataSource.data = [];
    this.dataSource.data = newAideSaisie;
    this.linkedIds = [];
    for (let node of this.treeControl.dataNodes) {
      setTimeout(() => {
        node.id = node.name + Date.now().toString();
        this.linkedIds.push("treeNode_" + node.id);
      }, 5);
    }
    //this.tree.renderNodeChanges(this.dataSource.data);
  }

  async dropped(event: any, node?: FlatTreeNode) {
    if (node) {
      const liste = this.listesBodyTable.objects[event.previousIndex];
      const choixListe = (await this._listeChoix.findByListeId(liste.id)).objects;
      const aideSaisieList = this.convertChoixToAide(choixListe);
      const refreshList = this.fillTree(aideSaisieList, this.dataSource.data, node);
      this.refreshDataSource(refreshList);
    } else {
      const liste = this.listesBodyTable.objects[event.previousIndex];
      const choixListe = (await this._listeChoix.findByListeId(liste.id)).objects;
      const aideSaisieList = this.convertChoixToAide(choixListe);
      const refreshList = this.fillTree(aideSaisieList, this.dataSource.data);
      this.refreshDataSource(refreshList);
    }
  }

  convertChoixToAide(choixList: Choix[]): AideSaisie[] {
    let aideSaisieList: AideSaisie[] = [];
    for (let choix of choixList) {
      const newAide = new AideSaisie(choix.nom);
      aideSaisieList.push(newAide);
    }
    return aideSaisieList;
  }

  fillTree(listToAdd: AideSaisie[], source: AideSaisie[], parentNode?: FlatTreeNode): AideSaisie[] {
    if (!source || source.length === 0) {
      return this.cloneList(listToAdd);
    } else {
      for (let node of source) {
        if (parentNode) {
          this.fillNode(listToAdd, node, parentNode);
        } else {
          this.fillNode(listToAdd, node);
        }
      }
      return source;
    }
  }

  fillNode(listToAdd: AideSaisie[], node: AideSaisie, parentNode?: FlatTreeNode) {
    if (parentNode) {
      if ((!node.children || node.children.length === 0) && node === parentNode.node) {
        node.children = this.cloneList(listToAdd);
      } else {
        for (let child of node.children) {
          this.fillNode(listToAdd, child, parentNode);
        }
      }
    } else {
      if (!node.children || node.children.length === 0) {
        node.children = this.cloneList(listToAdd);
      } else {
        for (let child of node.children) {
          this.fillNode(listToAdd, child);
        }
      }
    }
  }

  cloneList(list: AideSaisie[]): AideSaisie[] {
    return list.map((element) => element.clone());
  }

  resetDataSource() {
    this.dataSource.data = [];
    this.linkedIds = ["treeDrop"];
    this.tree.renderNodeChanges(this.dataSource.data)
    this.changeDetectorRefs.detectChanges();
  }

  nothing() { }

}
